export const firebaseConfig = {
  apiKey: 'AIzaSyDWMp9d0LFKHxTBdO7Qw8QswvhIAA5uIGY',
  authDomain: 'auth.fleato.com',
  projectId: 'fleato',
  storageBucket: 'fleato.appspot.com',
  messagingSenderId: '410686584435',
  appId: '1:410686584435:web:82844c3a0b4c8bb3975c06',
  webPushKeyPair: 'BCyMCuOfZ0jetv3uwyInmd8BEyY6JK0stOyTP5y0YJH4dyj3Z81fUpqhSEJ0-TY1Krp205lYK3QiysxTfEsf9aM'
};